// genericCanonicals — shared "don't let users pick this raw" list.
//
// Some canonicals are real registry entries — they exist for alias
// resolution, recipe matching, and OFF-payload binding — but are
// too generic to bind as a kitchen item on their own. Picking
// "chicken" with no cut tells the system nothing actionable for
// nutrition (165 kcal/100g for breast vs 209 for thigh), package
// size (everything from a 1 lb pack to a whole bird), or expiry
// (raw chicken vs cured chicken stick).
//
// Every wizard / search / re-link surface in the AddItem flow
// reads from this same set so the rules don't drift between
// pipelines.

export const GENERIC_ONLY = new Set([
  // Species roots — chicken_hub / beef_hub / pork_hub / turkey_hub
  // each have these as their species canonical, which the wizard
  // would otherwise surface as a tile-level pick.
  "chicken", "beef", "pork", "turkey",

  // Curated additional generics — too vague to bind without a
  // follow-up axis (state / cut / variety) that the wizard doesn't
  // ask for. Each line lists the proper alternatives the user
  // should drill to instead.
  "steak",       // → ribeye / ny_strip / sirloin / brisket / chuck_roast
  "mushroom",    // → cremini / portobello / shiitake / oyster_mushroom
  "cheese",      // → cheddar / mozzarella / parmesan / brie / feta…
  "milk",        // → whole_milk / skim_milk / almond_milk / oat_milk
  "bread",       // → sourdough / brioche / sandwich_bread / baguette
  "pasta",       // → spaghetti / penne / fettuccine / rigatoni
  "yogurt",      // → greek_yogurt / plain_yogurt / skyr
  "flour",       // → all_purpose_flour / bread_flour / cake_flour / 00
  "rice",        // → basmati / jasmine / arborio / long_grain
  "fish",        // → salmon / cod / halibut / tuna / branzino
]);

export function isGenericOnly(ingredientId) {
  if (!ingredientId) return false;
  return GENERIC_ONLY.has(ingredientId);
}
